<div *ngIf="hasNotes; else empty" fxLayout="column">
    <ng-container *ngFor="let note of model">
        <note *ngIf="!note.IsDeleted" [hideSubject]="hideSubject" [model]="note" (onDelete)="deleteNote(note)" [viewOnly]="viewOnly">
        </note>
    </ng-container>
</div>

<ng-template #empty>
    <div fxLayout="column" fxLayoutAlign="center center">
        <img alt="Illustration of blank notebook paper" src="https://cdn.forge.tylertech.com/v1/images/spot-hero/notes-empty-state-spot-hero.svg" style="width: 350px; height: 350px;">

        <div class="forge-typography--heading2">
            The notebook is empty.
        </div>
    </div>
</ng-template>